

<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
<h1 mat-dialog-title>Historial de cambios</h1>
<mat-divider></mat-divider>

<!-- Filtros: arrancan abiertos sólo si todavía no se buscó nada -->
  <mat-expansion-panel class="panel-filtros" [expanded]="!datosCargados">
    <mat-expansion-panel-header>
      <mat-panel-title>Filtros</mat-panel-title>
    </mat-expansion-panel-header>

    <form [formGroup]="filterForm">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field class="full-width">
            <mat-label>Propiedad</mat-label>
            <input matInput formControlName="nombrePropiedad" placeholder="Ej: Estado, Nombre">
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field class="full-width">
            <mat-label>Grupo de Cambio</mat-label>
            <input matInput formControlName="grupoCambio" placeholder="Ej: General, Seguridad">
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field class="full-width">
            <mat-label>Fecha Desde</mat-label>
            <input matInput [matDatepicker]="pickerDesde" formControlName="fechaCambioDesde">
            <mat-datepicker-toggle matSuffix [for]="pickerDesde"></mat-datepicker-toggle>
            <mat-datepicker #pickerDesde></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field class="full-width">
            <mat-label>Fecha Hasta</mat-label>
            <input matInput [matDatepicker]="pickerHasta" formControlName="fechaCambioHasta">
            <mat-datepicker-toggle matSuffix [for]="pickerHasta"></mat-datepicker-toggle>
            <mat-datepicker #pickerHasta></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="acciones-filtros">
        <button mat-flat-button color="primary" (click)="aplicarFiltros()">Buscar</button>
        <button mat-button (click)="limpiarFiltros()">Limpiar</button>
      </div>
    </form>
  </mat-expansion-panel>

  <!-- Spinner -->
  <ngx-spinner [zIndex]="100" name="spHistorialCambios" bdColor="rgba(255,255,255,0.8)"
    size="default" color="#009688" type="ball-atom" [fullScreen]="false">
  </ngx-spinner>

  <!-- Contenido con tabs -->
  <div  mat-dialog-content *ngIf="datosCargados">
    <mat-tab-group [(selectedIndex)]="selectedTab" class="custom-tabs">

      <!-- Tab: Listado -->
      <mat-tab>
        <ng-template mat-tab-label>Listado ({{dataSource.data.length}})</ng-template>

        <div class="tab-content">
          <mat-form-field class="search-field" appearance="outline">
            <mat-label>Buscar en el listado</mat-label>
            <input matInput (keyup)="applyFilter($event)">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <!-- El scroll va en este contenedor y no en el diálogo: sin un padre
               con overflow propio, el encabezado sticky se queda quieto pero las
               filas le pasan por arriba. -->
          <div class="tabla-scroll">
          <table mat-table [dataSource]="dataSource" matSort matSortActive="fechaCambio"
            matSortDirection="desc" matSortDisableClear class="custom-table">

              <!-- Columna Fecha -->
              <ng-container matColumnDef="fechaCambio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Fecha y hora
                </th>
                <td mat-cell *matCellDef="let element">
                  <span class="fecha">{{element.fechaCambio | date:'dd/MM/yyyy'}}</span>
                  <span class="hora">{{element.fechaCambio | date:'HH:mm'}}</span>
                </td>
              </ng-container>

              <!-- Columna Entidad -->
              <ng-container matColumnDef="nombreEntidad">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Entidad
                </th>
                <td mat-cell *matCellDef="let element">
                  <span class="entidad">{{element.nombreEntidad}}</span>
                  <span class="entidad-id">#{{element.idEntidad}}</span>
                </td>
              </ng-container>

              <!-- Columna Propiedad -->
              <ng-container matColumnDef="nombrePropiedad">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Propiedad
                </th>
                <td mat-cell *matCellDef="let element">
                  <span class="campo">{{element.nombrePropiedad}}</span>
                </td>
              </ng-container>

              <!-- Columna Valor Antiguo -->
              <ng-container matColumnDef="valorAntiguo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Valor anterior
                </th>
                <td mat-cell *matCellDef="let element">
                  <span class="valor anterior">{{element.valorAntiguo || '—'}}</span>
                </td>
              </ng-container>

              <!-- Columna Valor Nuevo -->
              <ng-container matColumnDef="valorNuevo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Valor nuevo
                </th>
                <td mat-cell *matCellDef="let element">
                  <span class="valor nuevo">{{element.valorNuevo || '—'}}</span>
                </td>
              </ng-container>

              <!-- Columna Grupo -->
              <ng-container matColumnDef="grupoCambio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Grupo
                </th>
                <td mat-cell *matCellDef="let element">
                  <!-- El grupo es un GUID: se muestran los primeros caracteres,
                       que alcanzan para reconocer que dos filas son del mismo
                       guardado, y el completo queda en el tooltip -->
                  <span class="grupo" *ngIf="element.grupoCambio" [matTooltip]="element.grupoCambio">
                    {{ element.grupoCambio.substring(0, 8) }}
                  </span>
                  <span class="vacio" *ngIf="!element.grupoCambio">—</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>

          <app-sin-datos *ngIf="dataSource.data.length === 0"
            icono="search_off"
            mensaje="Sin cambios registrados"
            detalle="Probá ampliando el rango de fechas o limpiando los filtros."
            [compacto]="true">
          </app-sin-datos>

            <!-- Paginador -->
            <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25"
              showFirstLastButtons [length]="dataSource.data.length">
            </mat-paginator>
        </div>
      </mat-tab>

      <!-- Tab: Estadísticas -->
      <mat-tab>
        <ng-template mat-tab-label>Estadísticas</ng-template>

        <div class="tab-content" *ngIf="estadisticas">

          <!-- Cards resumen -->
          <div class="stats-summary">
            <mat-card class="stat-card">
              <mat-icon class="stat-icon">all_inclusive</mat-icon>
              <div class="stat-content">
                <span class="stat-label">Total Cambios</span>
                <span class="stat-value">{{estadisticas.totalCambios}}</span>
              </div>
            </mat-card>

            <mat-card class="stat-card">
              <mat-icon class="stat-icon">first_page</mat-icon>
              <div class="stat-content">
                <span class="stat-label">Primer Cambio</span>
                <span class="stat-value small">{{estadisticas.primerCambio | date:'dd/MM/yyyy HH:mm'}}</span>
              </div>
            </mat-card>

            <mat-card class="stat-card">
              <mat-icon class="stat-icon">last_page</mat-icon>
              <div class="stat-content">
                <span class="stat-label">Último Cambio</span>
                <span class="stat-value small">{{estadisticas.ultimoCambio | date:'dd/MM/yyyy HH:mm'}}</span>
              </div>
            </mat-card>

            <mat-card class="stat-card" *ngIf="estadisticas.tiempoPromedioEntreCambiosDias > 0">
              <mat-icon class="stat-icon">timelapse</mat-icon>
              <div class="stat-content">
                <span class="stat-label">Promedio entre cambios</span>
                <span class="stat-value">{{estadisticas.tiempoPromedioEntreCambiosDias | number:'1.1-1'}} días</span>
              </div>
            </mat-card>
          </div>

          <!-- Gráficos principales -->
          <div class="charts-grid">

            <!-- Gráfico de línea temporal -->
            <mat-card class="chart-card full-width">
              <mat-card-header>
                <mat-icon mat-card-avatar>show_chart</mat-icon>
                <mat-card-title>Volumen de Cambios en el Tiempo</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="chart-selector">
                  <button mat-button [class.active]="periodoSeleccionado === 'dia'"
                    (click)="cambiarPeriodo('dia')">Día</button>
                  <button mat-button [class.active]="periodoSeleccionado === 'semana'"
                    (click)="cambiarPeriodo('semana')">Semana</button>
                  <button mat-button [class.active]="periodoSeleccionado === 'mes'"
                    (click)="cambiarPeriodo('mes')">Mes</button>
                </div>
                <div class="chart-container">
                  <canvas baseChart
                    [datasets]="lineChartData.datasets"
                    [labels]="lineChartLabels"
                    [options]="lineChartOptions"
                    [legend]="true"
                    [chartType]="'line'">
                  </canvas>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- Top Entidades -->
            <mat-card class="chart-card">
              <mat-card-header>
                <mat-icon mat-card-avatar>folder_open</mat-icon>
                <mat-card-title>Top 10 Entidades Modificadas</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="chart-container">
                  <canvas baseChart
                    [datasets]="barChartEntidades.datasets"
                    [labels]="barChartEntidadesLabels"
                    [options]="barChartOptions"
                    [legend]="false"
                    [chartType]="'bar'">
                  </canvas>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- Top Propiedades -->
            <mat-card class="chart-card">
              <mat-card-header>
                <mat-icon mat-card-avatar>label</mat-icon>
                <mat-card-title>Top 10 Propiedades Modificadas</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="chart-container">
                  <canvas baseChart
                    [datasets]="barChartPropiedades.datasets"
                    [labels]="barChartPropiedadesLabels"
                    [options]="barChartOptions"
                    [legend]="false"
                    [chartType]="'bar'">
                  </canvas>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- Distribución por Grupo -->
            <mat-card class="chart-card" *ngIf="estadisticas.distribucionPorGrupo.length > 0">
              <mat-card-header>
                <mat-icon mat-card-avatar>donut_large</mat-icon>
                <mat-card-title>Distribución por Grupo de Cambio</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="chart-container">
                  <canvas baseChart
                    [datasets]="pieChartGrupos.datasets"
                    [labels]="pieChartGruposLabels"
                    [options]="pieChartOptions"
                    [legend]="true"
                    [chartType]="'pie'">
                  </canvas>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- Heatmap por Hora -->
            <mat-card class="chart-card">
              <mat-card-header>
                <mat-icon mat-card-avatar>access_time</mat-icon>
                <mat-card-title>Cambios por Hora del Día</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="chart-container">
                  <canvas baseChart
                    [datasets]="barChartHoras.datasets"
                    [labels]="barChartHorasLabels"
                    [options]="barChartOptionsHoras"
                    [legend]="false"
                    [chartType]="'bar'">
                  </canvas>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- Cambios por Día de Semana -->
            <mat-card class="chart-card">
              <mat-card-header>
                <mat-icon mat-card-avatar>date_range</mat-icon>
                <mat-card-title>Cambios por Día de la Semana</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="chart-container">
                  <canvas baseChart
                    [datasets]="barChartDias.datasets"
                    [labels]="barChartDiasLabels"
                    [options]="barChartOptions"
                    [legend]="false"
                    [chartType]="'bar'">
                  </canvas>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- Top Cambios de Valor -->
            <mat-card class="chart-card full-width">
              <mat-card-header>
                <mat-icon mat-card-avatar>compare_arrows</mat-icon>
                <mat-card-title>Top 15 Transiciones de Valor</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="transitions-list">
                  <div class="transition-item" *ngFor="let cambio of estadisticas.topCambiosValor">
                    <div class="transition-header">
                      <span class="property-name">{{cambio.nombrePropiedad}}</span>
                      <span class="transition-count">{{cambio.cantidad}} veces</span>
                    </div>
                    <div class="transition-values">
                      <span class="old-value">{{cambio.valorAntiguo}}</span>
                      <mat-icon>arrow_forward</mat-icon>
                      <span class="new-value">{{cambio.valorNuevo}}</span>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- Anomalías -->
            <mat-card class="chart-card full-width" *ngIf="estadisticas.anomaliasFueraHorario.length > 0">
              <mat-card-header>
                <mat-icon mat-card-avatar color="warn">warning</mat-icon>
                <mat-card-title>Cambios Fuera de Horario Laboral</mat-card-title>
                <mat-card-subtitle>Últimos 20 cambios fuera del horario 06:00 - 20:00</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <div class="anomalies-list">
                  <div class="anomaly-item" *ngFor="let anomalia of estadisticas.anomaliasFueraHorario">
                    <mat-icon class="anomaly-icon">schedule</mat-icon>
                    <div class="anomaly-content">
                      <div class="anomaly-header">
                        <span class="anomaly-entity">{{anomalia.nombreEntidad}} #{{anomalia.idEntidad}}</span>
                        <span class="anomaly-date">{{anomalia.fechaCambio | date:'dd/MM/yyyy HH:mm'}}</span>
                      </div>
                      <span class="anomaly-description">{{anomalia.descripcion}}</span>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- Mensaje sin datos -->
  <div class="sin-busqueda" *ngIf="!datosCargados">
    <p>Elegí los filtros y apretá <b>Buscar</b> para ver el historial.</p>
  </div>


